export default __webpack_public_path__ + "static/media/aboutTopRight.c952a3db.png";